// extracted by mini-css-extract-plugin
export default {"fullWidth":"gn-z","image":"hn-z","lazyLoadPicture":"in-z","lazyLoadSpinner":"jn-z","lazyLoadSpin":"kn-z","lazyLoadImage":"ln-z","hasStyledAspectRatio":"mn-z"};